// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3whNV","tab":"ProcedureTabs_tab__2uusk"};